export default __webpack_public_path__ + "static/media/person_3@3x.d6a977ba.png";